let Preset = /*#__PURE__*/function (Preset) {
  Preset["RichText"] = "richtext";
  Preset["RichTextWithLists"] = "richtext-with-lists";
  Preset["InlineRichText"] = "inline";
  Preset["Text"] = "text";
  Preset["TextWithSoftBreaks"] = "text-with-soft-breaks";
  Preset["MetafieldRichText"] = "metafield-richtext";
  Preset["ThemeEditorRichText"] = "theme-editor-richtext";
  return Preset;
}({});

export { Preset };
